//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// @ is an alias to /src
import moment from 'moment'
import { mapState } from 'vuex'
export default {
  name: 'UsersList',
  data() {
    return {
      list: []
    }
  },
  components: {
  },
  computed: mapState({
    user: state => state.user.user
  }),
  mounted() {
    this.getUsersByOpenId()
  },
  methods: {
    getDate (createdAt) {
      return moment(createdAt).format('MM-DD')
    },
    getUsersByOpenId () {
      this.$store.httpDispatch({})('getUsersByOpenId')
      .then((res) => {
        console.log(res.data)
        if (res.data.code === 0) {
          this.list = res.data.data.users
          this.list = this.list.map((user) => {
            user.consume = 0
            user.orders.forEach(order => {
              user.consume = user.consume + order.order_total_price - order.order_express_price
            })
            return user
          })
        }
      })
    }
  }
}
